<svg-icon src="/assets/shared/icons/refresh-open-arrow.svg"></svg-icon>
<h2 class="title">{{ 'A new version of ' + productName + ' is available!' | translate | async }}</h2>
<p class="instructions">{{ 'Refresh this page for the latest and greatest version.' | translate | async }}</p>
<a [href]="appUrl" class="button button-pill button-reverse button-refresh">{{ 'Refresh' }}</a>
